(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-menu-alt"] && !Shopify.designMode) return;
  try {
    
  class StickyHeaderMobile extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.currentScrollTop = 0;
      this.isHidden = false;

      this.headerBounds = {
        top: this.offsetTop,
        bottom: this.offsetTop + this.offsetHeight
      };

      this.setHeaderHeight();

      // Bind
      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);

      // Events
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      document.addEventListener('shopify:section:load', () => {
        this.setHeaderHeight();
        this.updateBounds();
      });

      // Initial
      this.updateBounds();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    // =========================
    // HEIGHT
    // =========================
    setHeaderHeight() {
      const height = this.offsetHeight;
      if (height) {
        document.documentElement.style.setProperty(
          '--mobile-header-height',
          `${height}px`
        );
      }

      const header = document.querySelector('.marqueee-newww');
      if (!header) return;

      const top = header.offsetHeight;

      document.documentElement.style.setProperty('--header-height-new-stick', top + 'px');
    }

    updateBounds() {
      const rect = this.getBoundingClientRect();
      const scrollTop = window.scrollY;

      this.headerBounds = {
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop
      };
    }

    // =========================
    // SCROLL
    // =========================
    onScroll() {
      const scrollTop = window.scrollY;

      // Scroll DOWN → hide
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.hide();
      }

      // Scroll UP → show
      else if (scrollTop < this.currentScrollTop) {
        this.show();
      }

      // Top → reset
      if (scrollTop <= 0) {
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    // =========================
    // STATES
    // =========================
    hide() {
      if (this.isHidden) return;

      this.parentElement.classList.add('mm-header-hide');
      this.parentElement.classList.remove('mm-header-show');

      this.isHidden = true;
    }

    show() {
      if (!this.isHidden) return;

      this.parentElement.classList.add('mm-header-show');
      this.parentElement.classList.remove('mm-header-hide');

      this.isHidden = false;
    }

    reset() {
      this.parentElement.classList.remove('mm-header-hide', 'mm-header-show');
      this.isHidden = false;
    }
  }

  customElements.define('sticky-header-mobile', StickyHeaderMobile);


  

  } catch(e) { console.error(e); }
})();
})();
